module.exports = __webpack_public_path__ + "static/media/traycorp9.3c29ccd0.png";